import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { lastValueFrom } from 'rxjs';
import { DialogConfirmationComponent } from 'src/app/includes/census-patient-list/dialog-confirmation/dialog-confirmation.component';
import { CptIcdAssociationService } from 'src/app/includes/cpt-icd-association/cpt-icd-association.service';
import { PatientRoundingSheetService } from 'src/app/includes/patient-rounding-sheets/patient-rounding-sheet.service';
import { AuthService } from 'src/app/services/auth.service';
import { WoundService } from 'src/app/services/wound.service';
import { ProcedureType, ProcedureDataset } from '../procedure-datasets.component';

@Component({
  selector: 'app-procedure-category-data',
  templateUrl: './procedure-category-data.component.html',
  styleUrls: ['./procedure-category-data.component.css']
})
export class ProcedureCategoryDataComponent implements OnInit, OnChanges {
  @Input() company_id: string;
  @Input() procedureDatasets: ProcedureDataset[] = [];
  @Input() activeProcedureType: ProcedureType;
  dataSource = new MatTableDataSource();
  selectedCode = new FormControl();
  displayedColumns: string[] = ['category', 'size', 'code_1', 'code_2', 'code_3', 'operation'];
  loaderId = "app-cpt-icd-association";
  cptCodeList: any = [];
  cptCodeNewList: any = [];


  searchText: any;
  diagnoseFilter = '';
  filter: any;

  showNewProcedureDatasetInput: boolean = false;
  disableAddButton = false;
  currentUser: any;


  constructor(
    private _cpticd: CptIcdAssociationService,
    private loader: NgxUiLoaderService,
    private _toaster: ToastrService,
    private _wound: WoundService,
    private _authService: AuthService,
    private patientRoundingSheetService: PatientRoundingSheetService,
    private dialog: MatDialog
  ) {
    this.currentUser = this._authService.currentUser;
   }
  async ngOnInit() {
    // this.loader.startLoader(this.loaderId);
    // await this.initProcedureDatasets();
    this.init();
    // this.initCPTCodes
    // this.loader.stopLoader(this.loaderId);
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.procedureDatasets?.firstChange) {
      this.init();
    }
  }
  async init() {
    if(localStorage.getItem("procedureDatasets")){
      this.procedureDatasets = JSON.parse(localStorage.getItem("procedureDatasets"));
    }else{
      this.procedureDatasets.forEach(ele => {
        ele["selected"] = false;
      });
      localStorage.setItem("procedureDatasets",JSON.stringify(this.procedureDatasets));
    }
    this.dataSource.data = this.procedureDatasets;
    if (this.procedureDatasets.length == 0) {
      await this.searchCPT("");
    } else {
      this.populateCPTsDropdownValues();
    }
  }
  async initProcedureDatasets() {
    
    let { status, data } = await lastValueFrom(this._wound.getProcedureDatasets(this.activeProcedureType._id)) as any;
    if (status == 200) {
      this.procedureDatasets = data.array as ProcedureDataset[];
      // this.selectedICDCode = this.icdCodeList.find(icdcode => icdcode.code == this.woundEtiologyGroupDetails.icd_id.code);
      // 

    }
  }
  handleCode1Change($event, element) {
    console.log('handleCode1Change')
    element.code_1 = $event.value;
  }
  handleCode2Change($event, element) {
    console.log('handleCode2Change')
    element.code_2 = $event.value;
  }
  handleCode3Change($event, element) {
    console.log('handleCode3Change')
    element.code_3 = $event.value;
  }
  handleNewCode1Change($event, element?) {
    // if(element) {
    //   this.selectedCode1[element._id] = $event.value;
    //   element.icd_code = $event.value;
    //   console.log('handleICDChange');
    //   this.updateProcedureDataset(
    //     element
    //   )
    // } else {
    //   this.newSelectedDetailICDInputValue = $event.value  
    // }
  }
  async searchCPT(value) {
    await this.getAllCPTs(value);
    this.populateCPTsDropdownValues();
  }
  populateCPTsDropdownValues() {
    const _cptCodeList = [...this.cptCodeList];
    for (const dataset of this.procedureDatasets) {

      if (dataset?.code_1 && !_cptCodeList.find(x => x && x._id === dataset.code_1._id)) {
        this.cptCodeList.push(dataset.code_1);
      }
      if (dataset?.code_2 && !_cptCodeList.find(x => x && x._id === dataset.code_2._id)) {
        this.cptCodeList.push(dataset.code_2);
      }
      if (dataset?.code_3 && !_cptCodeList.find(x => x && x._id === dataset.code_3._id)) {
        this.cptCodeList.push(dataset.code_3);
      }
    }
    // this.cptCodeList = _cptCodeList
  }

  async updateProcedureDataset(procedureDataset) {
    let { _id: procedureDatasetId, category, size, code_1, code_2, code_3, template, is_deleted } = procedureDataset;

    const { status, data } = await lastValueFrom(this._wound.updateProcedureDataset(
      procedureDatasetId,
      category, size, code_1._id, code_2._id, code_3._id, template, is_deleted
    )) as any;
    console.log({
      status, data
    });
  }

  async deleteProcedureDataset(procedureDataset, i) {
    const { status, data } = await lastValueFrom(this._wound.updateProcedureDataset(
      procedureDataset._id,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      true
    )) as any;
    console.log({
      status, data
    });
    if (status == 200) {
      this.procedureDatasets.splice(i, 1);
    }
  }
  onTagSelect(tag, element) {
    // element.tags.push($event);
    console.log('onTagSelect', { tag, element });
    this.updateProcedureDataset(element)


  }
  onTagDeSelect(tag, element) {
    console.log('onTagDeSelect', { tag, element })
    this.updateProcedureDataset(element)
  }

  handleAddNewProcedureDataset() {
    this.procedureDatasets.push({
      _id: null,
      procedure_type_id: this.activeProcedureType._id,
      category: '',
      size: '',
      code_1: null,
      code_2: null,
      code_3: null,
      selected: false
    } as any);
    this.dataSource.data = this.procedureDatasets;
  }
  async handleProcedureDatasets(procedureDataset, index) {
    if (procedureDataset.selected) {
      let obj = {
        category: procedureDataset.category,
        size: procedureDataset.size,
        code_1: procedureDataset.code_1
      };
      let message = "Enter ";
      message += !obj['category'] ? "Category " : "";
      message += !obj['size'] ? "Size " : "";
      message += !obj['code_1'] ? "Code 1" : "";
      if (message.length != 6) {
        this._toaster.error(message, "Failed");
      } else {
        const infoToast = this._toaster.info('Updating Category', 'Please wait', { disableTimeOut: true });
        const { data, status } = await lastValueFrom(this._wound.updateProcedureDataset(procedureDataset._id, procedureDataset.category, procedureDataset.size, procedureDataset?.code_1?._id, procedureDataset?.code_2?._id, procedureDataset?.code_3?._id)) as any;
        if (status == 200) {
          this._toaster.clear(infoToast.toastId);
          this._toaster.success("Updated Successfully", "Success");
          this.procedureDatasets[index]["selected"] = false;
          localStorage.setItem("procedureDatasets",JSON.stringify(this.procedureDatasets));
        }
      }
    } else {
      this.addProcedureDataset(procedureDataset);
    }
  }
  async addProcedureDataset(procedureDataset) {
    let obj = {
      category: procedureDataset.category,
      size: procedureDataset.size,
      code_1: procedureDataset.code_1
    };
    let message = "Enter ";
    message += !obj['category'] ? "Category " : "";
    message += !obj['size'] ? "Size " : "";
    message += !obj['code_1'] ? "Code 1" : "";
    if (message.length != 6) {
      this._toaster.error(message, "Failed");
    } else {
      const infoToast = this._toaster.info('Adding Category', 'Please wait', { disableTimeOut: true });
      this.disableAddButton = true;
      const newRowIndex = this.procedureDatasets.findIndex((x: any) => x._id === null);
      const { data, status } = await lastValueFrom(this._wound.addProcedureDataset(procedureDataset.procedure_type_id, procedureDataset.category, procedureDataset.size, procedureDataset?.code_1?._id, procedureDataset?.code_2?._id, procedureDataset?.code_3?._id)) as any;
      if (status == 200) {
        this.dataSource.data[newRowIndex]['_id'] = this.procedureDatasets[newRowIndex]._id = data._id;
        this._toaster.clear(infoToast.toastId);
        this._toaster.success("Added Successfully", "Success");
        localStorage.setItem("procedureDatasets",JSON.stringify(this.procedureDatasets));
      }
      this.disableAddButton = false;
    }
  }

  async deleteNewProcedureDataset(procedureDataset, newRowIndex) {
    let dialogRef = this.dialog.open(DialogConfirmationComponent, {
      data: {
        message: "Are you sure you want to delete this category?"
      }
    });
    dialogRef.afterClosed().subscribe(async result => {
      if (result === "true") {
        const infoToast = this._toaster.info('Deleting Category', 'Please wait', { disableTimeOut: true });
        const { data, status } = await lastValueFrom(this._wound.updateProcedureDataset(procedureDataset._id, undefined, undefined, undefined, undefined, undefined, undefined, true)) as any;
        
        if (status == 200) {
          this.procedureDatasets.splice(newRowIndex, 1);
          this.dataSource.data = this.procedureDatasets;
          this._toaster.clear(infoToast.toastId);
          this._toaster.success("Deleted Successfully", "Success");
          localStorage.setItem("procedureDatasets",JSON.stringify(this.procedureDatasets));
        }
      }
    });
  }

  async getAllCPTs(search = "") {
    const { status, data } = await lastValueFrom(this.patientRoundingSheetService.getCPTs({ page: 1, search: search })) as any
    if (status == 200) {
      this.cptCodeList = data.array;
    } else {
      this.cptCodeList = []
    }
  }

  isAddingNewProcedureDataset() {
    return !!this.procedureDatasets.find(e => e._id == null)
  }
  clearCode3(element) {
    element.code_3 = null;
  }

  cptCodeDisplay(cpt) {
    let label = '';
    if (cpt) {
      if (cpt.code) {
        label += cpt.code;
      }
      if (cpt.description) {
        label += ' (' + cpt.description + ')';
      }
    }
    return label.trim();
  }
  toggletoUpdate(element, index) {
    this.procedureDatasets[index]["selected"] = true;
  }
}
